module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/mail_mv_bg_mobile-a631472635986efcdd91e9a4d67550c0.png";